import { HttpResponse, HttpService } from '@application/http.service';
import type { ClientPersonalizedCaseApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable, Scopes } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable({
	scope: Scopes.Transient,
})
export class MessagingConversationsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('MessagingConversations');
	}

	public getMessagingConversation(id: string): HttpResponse<ClientPersonalizedCaseApiModel> {
		return this.httpService.get(`${this.baseUri}/case/${id}`);
	}

	public endMessagingConversation(id: string): HttpResponse<unknown> {
		return this.httpService.put(`${this.baseUri}/${id}/completed`, null);
	}
}
